// extracted by mini-css-extract-plugin
export var scrollArea = "_nm-0";